import {
	List,
	Datagrid,
	TextField,
	EditButton,
	CreateButton,
	TopToolbar,
	useResourceContext,
	useCanAccess,
	ReferenceManyCount
} from 'react-admin';

const PersonaListActions = () => (
	<TopToolbar>
		<CreateButton />
	</TopToolbar>
);

const list = (props) => {
		const resource = useResourceContext(props);
		const { canAccess, isPending } = useCanAccess({
			action: 'edit',
			resource
		});

		const rowClick = !canAccess || isPending ? 'show' : 'edit';
		
	return (
		<List
			actions={<PersonaListActions />}
			exporter={false}
		>
			<Datagrid rowClick={rowClick}>
				<TextField source="name" />
				<TextField source="description" />
				<EditButton />
			</Datagrid>
		</List>
	);

}

export default list;
